import templateUrl from './createProductGroupDialog.html'
import { tmrDialogController } from 'tmr/controllers/dialog/dialog'
import './createProductGroupDialog.scss'

/**
 * Configures dialog Items by Upc (preset `tmrCreateProductGroupDialog`).
 *
 * @type {ngConfig}
 */
function tmrCreateProductGroupDialogDialogConfig($mdDialogProvider) {
  'ngInject'
  $mdDialogProvider.addPreset('tmrCreateProductGroupDialog', {
    options: /*@ngInject*/ () => ({
      templateUrl,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: 'tmrCreateProductGroupDialogDialogController',
      controllerAs: '$ctrl',
      bindToController: true,
      locals: {
        productGroup: null,
      },
    }),
  })
}

export { tmrCreateProductGroupDialogDialogConfig as config }

/**
 * Controller of Dialog {@link tmrCreateProductGroupDialogDialogConfig tmrCreateProductGroupDialog}.
 *
 * @type {ngController}
 */
export class tmrCreateProductGroupDialogDialogController extends tmrDialogController {
  constructor(
    $mdDialog,
    $transitions,
    Product,
    TmrToast,
    ProductGroup,
    productGroup
  ) {
    'ngInject'
    super($mdDialog, $transitions)
    Object.assign(this, { Product, TmrToast, ProductGroup, productGroup })
  }

  $onInit() {
    super.$onInit()
    this.delay = 500
    this.updatingCount = false
    if (this.productGroup) {
      this.sizes = [].concat(this.productGroup.sizes)
      this.styles = [].concat(this.productGroup.styles)
      this.colors = [].concat(this.productGroup.colors)
      this.materials = [].concat(this.productGroup.materials)
      this.updateCount()
    } else this.clear()
  }

  clear() {
    this.productCount = undefined
    this.styles = []
    this.materials = []
    this.colors = []
    this.sizes = []
  }

  updateCount() {
    this.updatingCount = true
    this.Product.count(this.getFilterParams())
      .then(res => (this.productCount = res))
      .catch(err => this.TmrToast.exception(err))
      .finally(() => (this.updatingCount = false))
  }

  confirm() {
    this.$mdDialog.hide(this.getCreateParams())
  }

  getFilterParams() {
    return {
      'color.value': this.colors,
      'material.value': this.materials,
      'size.value': this.sizes,
      'style.value': this.styles,
    }
  }

  getCreateParams() {
    if (
      this.colors.length ||
      this.materials.length ||
      this.sizes.length ||
      this.styles.length
    ) {
      return {
        productGroup: {
          colors: this.colors,
          materials: this.materials,
          sizes: this.sizes,
          styles: this.styles,
        },
        filters: {
          styles: this.styles.join(', '),
          materials: this.materials.join(', '),
          sizes: this.sizes.join(', '),
          colors: this.colors.join(', '),
        },
      }
    } else {
      return {
        productGroup: null,
        filters: null,
      }
    }
  }

  querySearch(attribute, value) {
    const attr = {
      attributename: attribute,
      value: value,
    }
    switch (attribute) {
      case 'style':
        attr.excludeList = this.styles
        break
      case 'material':
        attr.excludeList = this.materials
        break
      case 'color':
        attr.excludeList = this.colors
        break
      case 'size':
        attr.excludeList = this.sizes
        break
    }
    return this.Product.attributeSuggestion(attr).$promise
  }

  show() {
    return (
      this.sizes.length > 0 ||
      this.materials.length > 0 ||
      this.styles.length > 0 ||
      this.colors.length > 0
    )
  }

  close() {
    return this.$mdDialog.cancel()
  }
}
